import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";

import client from "../../shared/api/client";
import { toastError } from "../../shared/toastHelper";
import OnboardingChecklist from "./components/OnboardingChecklist";

const OnboardingContext = createContext();

export function useOnboardingContext() {
  return useContext(OnboardingContext);
}

const OnboardingApp = (props) => {
  const [checklist, setChecklist] = useState(props.checklist);
  const [pendingTaskIds, setPendingTaskIds] = useState([]);

  const toggleTask = async (task) => {
    const status = task.status === "done" ? "open" : "done";
    setPendingTaskIds((ids) => [...ids, task.id]);
    try {
      const response = await client.patch(
        `/teams/${props.team.id}/onboarding/tasks/${task.id}`,
        { status }
      );
      setChecklist(response.data);
    } catch (error) {
      toastError("We couldn't update that task. Please try again.");
    } finally {
      setPendingTaskIds((ids) => ids.filter((id) => id !== task.id));
    }
  };

  return (
    <OnboardingContext.Provider value={{ checklist, toggleTask, pendingTaskIds }}>
      <ToastContainer icon={false} />
      <OnboardingChecklist />
    </OnboardingContext.Provider>
  );
};

OnboardingApp.propTypes = {
  checklist: PropTypes.object,
  team: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
};

export default OnboardingApp;
